"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const sdk_logs_1 = require("@opentelemetry/sdk-logs");
const configuration_1 = require("../configuration");
class LoggerProvider extends sdk_logs_1.LoggerProvider {
    constructor() {
        super(...arguments);
        // Used to keep track of logRecordProcessors to avoid adding the same processor multiple times
        // as parent class does not have a way to check if a processor is already added.
        this.logRecordProcessors = new Set();
    }
    static getInstance() {
        if (!this._instance) {
            this._instance = new LoggerProvider();
        }
        return this._instance;
    }
    getLogger(serviceName, serviceVersion) {
        var _a, _b;
        if (configuration_1.Configuration.isSdkStarted) {
            const configuration = configuration_1.Configuration.instance;
            if (configuration.logRecordProcessor && !this.logRecordProcessors.has(configuration.logRecordProcessor)) {
                this.logRecordProcessors.add(configuration.logRecordProcessor);
                this.addLogRecordProcessor(configuration.logRecordProcessor);
            }
            if (!serviceName) {
                serviceName = configuration.serviceName;
            }
            if (!serviceVersion) {
                serviceVersion = configuration.serviceVersion;
            }
        }
        if (!serviceName) {
            serviceName = ((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.SERVICE_NAME) || ((_b = process === null || process === void 0 ? void 0 : process.env) === null || _b === void 0 ? void 0 : _b.OTEL_SERVICE_NAME) || '{{SERVICE_NAME}}';
        }
        return super.getLogger(serviceName, serviceVersion);
    }
}
exports.default = LoggerProvider.getInstance();
//# sourceMappingURL=loggerProvider.js.map